import { useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../../Context/AuthContext';

const resetOnRepairStatus = async (id, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/freight/trucks/${id}/set-on-repairing-false`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to reset on-repair status');
  }

  return response.json();
};

const useOnRepairStatus = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);

  return useMutation(({ id }) => resetOnRepairStatus(id, token), {
    onSuccess: () => {
      queryClient.invalidateQueries(['truck']);
    },
  });
};

export default useOnRepairStatus;
